import { useState, useEffect } from 'react';
import { elements } from '../data';
import { getAnimationClass } from './../utils';

export default function NormDefault({ onComplete }) {
  const [showP, setShowP] = useState(false);
  const [showH3, setShowH3] = useState(false);
  const [showDebitCreditView, setShowDebitCreditView] = useState(false);

  const debitElements = [elements[0], elements[4]];
  const creditElements = elements.slice(1, 4);

  useEffect(() => {
    const timeouts = [];
    let currentTime = 500;
    
    timeouts.push(setTimeout(() => setShowP(true), currentTime));
    
    currentTime += 6000;
    timeouts.push(setTimeout(() => setShowH3(true), currentTime));
    
    currentTime += 500;
    timeouts.push(setTimeout(() => setShowDebitCreditView(true), currentTime));
    
    currentTime += 4500;
    timeouts.push(setTimeout(() => onComplete?.(), currentTime));
    
    return () => timeouts.forEach(clearTimeout);
  }, [onComplete]);

  return (
    <>
      <h1 className="animate-fade-in">Normal Balances</h1>
      
      <p className={getAnimationClass(showP)}>
        Now, use your knowledge of <b>the 5 Elements' normal balances</b> to sort the various accounts that will appear in this level. <b className="red">Pro tip</b>: an account's normal balance comes from the Element it belongs to. For example, since Assets normally have a debit balance, the Cash account should to. 
      </p>

      {showH3 && (
        <h3 className={getAnimationClass(showH3)}>
          The Normal Balances of the 5 Elements
        </h3>
      )}

      {showDebitCreditView && (
        <div className={`transition-debit-credit-view level-default ${getAnimationClass(showDebitCreditView)}`}>
          <div className="debit-credit-container">
            <span>Debit Balance</span>
            <div className="debit-credit-view-elements">
              {debitElements.map(({ name, color }, i) => (
                <div
                  key={i}
                  className="transition-element"
                  style={{ backgroundColor: color }}
                >
                  {name}
                </div>
              ))}
            </div>
          </div>
          <div className="debit-credit-container">
            <span>Credit Balance</span>
            <div className="debit-credit-view-elements">
              {creditElements.map(({ name, color }, i) => (
                <div
                  key={i}
                  className="transition-element"
                  style={{ backgroundColor: color }}
                >
                  {name}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
}